import { useState, useEffect, useContext } from "react"
import { useGetUser, useGetToken } from "../../../Hooks/CustomHooks"
import SelectList from "../../../Components/Select/SelectList"
import { GetRuc, ContratoList, GetContratosList } from "../../../api/Api"
import { Button } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { useQuery } from "react-query"
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { SessionContext } from '../../../Components/Context/SessionContext';

export default function SeleccionarContrato({ title }) {
    const { session, setSession } = useContext(SessionContext);
    const user = useGetUser(),
        token = useGetToken(),
        [refresh, setRefresh] = useState(false),
        history = useHistory();
    
    const { data: dataListContratos, error, isLoading } = useQuery("listContratos", async () => {
        const d = await GetContratosList(user.email);
        const itemDefault = d.data.list.find(e => e.value === d.data.defaultId);
        setSelectedOption(itemDefault);
        return d.data.list;
    });
    
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSelectChange = (selectedOption) => {
        setSelectedOption(selectedOption);
        //console.log('Opción seleccionada:', selectedOption);
    };

    const handleClick = () => {
        console.info(selectedOption, "selectedOption");
        setSession({...session, 
            "ruc": selectedOption.ruc,
            "nroContrato": selectedOption.nroContrato,
            "idLocatario": selectedOption.value});
        
        localStorage.setItem('idLocatario', selectedOption.value)
        localStorage.setItem('nroContrato', selectedOption.nroContrato)
        history.push('/locatario/dashboard')
        // return;
        // localStorage.setItem('idLocatario', idLocatario.value)
        // localStorage.setItem('nroContrato', idLocatario.extraValue)
        
        // history.push('/locatario/dashboard')
    }
    useEffect(()=> {
        console.info(session, "Session!!!!");
    },[])

    return (
        <>
            <div className="row d-flex h-100 justify-content-center">
                <div className="align-items-center col-5 d-flex flex-column justify-content-center">
                    <div className="card w-100">
                        <div className="align-items-center card-header d-flex">
                            <h2>Seleccionar Contrato</h2>
                        </div>
                        <div className="card-body pt-6">
                            <Select
                                options={dataListContratos}
                                value={selectedOption}
                                onChange={handleSelectChange}
                            />
                            <Button variant="primary" onClick={handleClick} className="mt-6">Continuar</Button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}